<span [matTooltip]="job?.progress?.description">
  {{ appStatus | mapValue: appStatusLabels | translate }}
</span>
